import { getUserInfo } from '../utils/userApi'
import { useEffectAsync } from '../utils/common'
import PageLock from './PageLock'
import { memo, useState } from 'react'
import { useLoading } from './Loading'
import { useLocation, useNavigate } from 'react-router-dom'

const NeedLogin = memo(({ children, setUserInfo, allowAnonymous = false }) => {
    const [isLogined, setLogined] = useState(false)
    const { setLoading } = useLoading()
    const location = useLocation()
    const navigate = useNavigate()

    useEffectAsync(async () => {
      if (allowAnonymous) return
      setLoading(true)
      const r = await getUserInfo()
      console.info(r)
      setLoading(false)
      const succ = r?.code === 0
      setLogined(succ)
      setUserInfo(succ ? r.data : null)
      if (succ) return
      navigate(`/login?redirect=${location.pathname}${location.search}`)

    }, [])

    return <PageLock enable={!isLogined && !allowAnonymous}
                     useSkeleton={true}>
      {children}
    </PageLock>
  },
)

export default NeedLogin